var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.75C2.75 12.8717 3.59285 14.9066 5.09315 16.4069C6.59344 17.9071 8.62827 18.75 10.75 18.75M2.75 10.75C2.75 8.62827 3.59285 6.59344 5.09315 5.09315C6.59344 3.59285 8.62827 2.75 10.75 2.75M2.75 10.75H0.75M10.75 18.75C12.8717 18.75 14.9066 17.9071 16.4069 16.4069C17.9071 14.9066 18.75 12.8717 18.75 10.75M10.75 18.75V20.75M18.75 10.75C18.75 8.62827 17.9071 6.59344 16.4069 5.09315C14.9066 3.59285 12.8717 2.75 10.75 2.75M18.75 10.75H20.75M10.75 2.75V0.75M7.75 10.75C7.75 11.5456 8.06607 12.3087 8.62868 12.8713C9.19129 13.4339 9.95435 13.75 10.75 13.75C11.5456 13.75 12.3087 13.4339 12.8713 12.8713C13.4339 12.3087 13.75 11.5456 13.75 10.75C13.75 9.95435 13.4339 9.19129 12.8713 8.62868C12.3087 8.06607 11.5456 7.75 10.75 7.75C9.95435 7.75 9.19129 8.06607 8.62868 8.62868C8.06607 9.19129 7.75 9.95435 7.75 10.75Z",
    stroke: "#343434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFrom);
export default __webpack_public_path__ + "static/media/location-from.66e4974cd15ced0fe7854a2e83e87b7b.svg";
export { ForwardRef as ReactComponent };